import Vue from "vue";
import Vuex from "vuex";

import { staticGetters } from "./staticGetters";
import { mockState } from "./utilities";
import { api, http } from "./http";
import { TelepathyFormData } from "./TelepathyFormData";

Vue.use(Vuex);

export default new Vuex.Store({
    state: mockState("clean"),
    mutations: {
        change(state, payload) {
            state[payload.prop] = payload.val;
            console.log("Property: " + payload.prop + " changed to - ", payload.val);
        },
        reset(state) {
            state.messageType = "";
            state.audioType = "";
            state.audioUploadType = "";
            state.contactListType = "";
            state.message = "";
            // TODO: This has to be fixed
            state.selectedCaller = 1;
            state.selectedList = null;
            state.recording = null;
        },
        sanitize(state) {
            const campaign = {};
            campaign.caller = state.selectedCaller;
            campaign.list = state.selectedList;
            campaign.name = "Example Campaign";
            campaign.messageType = state.messageType;

            if (campaign.messageType == "sms") {
                campaign.message = state.message;
            }
            else if (campaign.messageType == "audio") {
                campaign.audioType = state.audioType;
                campaign.recording = state.recording;
                campaign.description = "This is a campaign";
            }
            state.campaign = campaign;
        },
        auth_request(state){
            state.status = "loading";
        },
        auth_success(state, { token, user }){
            state.status = "success";
            state.token = token;
            state.user = user;
        },
        auth_error(state){
            state.status = "error";
        },
        logout(state){
            state.status = "";
            state.token = "";
        },
    },
    actions: {
        async login({ commit }, credentials) {
            try {
                const { data } = await http({
                    method: "post",
                    url: "/jsonlogin",
                    data: credentials,
                });

                const { token, user } = data;
                commit("auth_success", { token, user });

                localStorage.setItem("token", token);
                api.defaults.headers.Authorization = token;

                return data;
            } catch (error) {
                commit("auth_error");
                localStorage.removeItem("token");
                throw error.response.data;
            }
        },
        async register({ commit }, { email, password, firstName, lastName, phoneNumber }) {
            const data = new FormData();
            data.append('email', email);
            data.append('password', password);
            data.append('firstName', firstName);
            data.append('lastName', lastName);
            data.append('phoneNumber', phoneNumber);

            try {
                const response = await http.post("/register", data);
                if (response.status === 200) {
                    const { token, user } = response.data;
                    commit("auth_success", { token, user });

                    localStorage.setItem("token", token);
                    api.defaults.headers.Authorization = token;

                    return response.data;
                }
            } catch (error) {
                commit("auth_error");
                localStorage.removeItem("token");
                throw error.response.data;
            }
        },
        async logout({ commit }){
            try {
                await http.get('/logout');
            } catch (error) {
                commit("logout");
                localStorage.removeItem("token");
                delete api.defaults.headers.Authorization;
            }

            return true;
        },
        async sanitizeAndSend({ commit }) {
            commit("sanitize");

            const { campaign } = this.state;

            if (campaign.messageType === "sms") {
                const data = new TelepathyFormData("send_sms_request");

                data
                    .append("caller", campaign.caller)
                    .append("campaign_name", campaign.name)
                    .append("sms_text", campaign.message)
                    .append("contact_list", campaign.list)
                ;

                return await api.post("sms", data);
            }
            else if (campaign.messageType === "audio") {

                if (campaign.audioType === "voice") {
                    const data = new TelepathyFormData("send_voice_request");

                    data
                        .append("caller", campaign.caller)
                        .append("campaign_name", campaign.name)
                        .append("recording", campaign.recording)
                        .append("contact_list", campaign.list)
                    ;

                    return await api.post("voices", data);
                }
                else if (campaign.audioType === "voicemail") {
                    const data = new TelepathyFormData("send_voicemail_request");

                    data
                        .append("campaign_name", campaign.name)
                        .append("description", campaign.description)
                        .append("recording", campaign.recording)
                        .append("contact_list", campaign.list)
                        .append("caller", campaign.caller)
                    ;

                    return await api.post("voicemails", data);
                }
            }
        },
        commitMultiple({ commit }, payloads) {
            for (const payload of payloads) {
                commit("change", {
                    prop: payload.prop,
                    val: payload.val
                });
            }
        },
        async loadRecordings({ commit }) {
            let { data: { payload: recordings } } = await api.get("recordings");

            commit("change", {
                prop: "recordings",
                val: recordings || []
            });
        },
        async loadCallers({ commit }) {
            let { data: { payload: callers } } = await api.get("callers");

            commit("change", {
                prop: "callers",
                val: callers || []
            });
        },
        async loadLists({ commit }) {
            let { data: { payload: lists } } = await api.get("lists") || [];

            commit("change", {
                prop: "lists",
                val: lists || []
            });
        },
        async loadCampaigns({ commit }) {
            const { data: campaigns } = await api.get("campaigns");

            commit("change", {
                prop: "campaigns",
                val: campaigns
            });
        }
    },
    modules: {
    },
    getters: {
        ...staticGetters,
        messageTypeFormatted: state => {
            if(state.messageType === "sms") {
                return "Text Message";
            } else if (state.messageType === "audio") {
                if(state.audioType === "voice") {
                    return "Phonemail";
                } else if (state.audioType === "voicemail") {
                    return "Voicemail";
                } else {
                    return "Audio Message";
                }
            }
        },
        contactList: state => id => {
            return state.lists.find(list => list.id === id);
        },
        uploadedFileName: state => id => {
            let recording = state.recordings.find(recording => recording.id === id);
            if (recording !== undefined) {
                return recording.file_name;
            } else {
                return "Audio file not found";
            }
        },
        findRecordingById: state => id => {
            return state.recordings.find(recording => recording.id === id);
        },
        findFullListById: state => id => {
            return state.listsFull.find(list => list.id === id);
        },
        findCallerById: state => id => {
            return state.callers.find(caller => caller.id == id);
        },
        isLoggedIn: state => !!state.token,
    }
});
